<template>
	<div class="px-2">
		<template v-for="(exemplar, i) in exemplars">
			<div :key="`t-${exemplar.id}`" class="title-card card box">
				<i
					class="fas ml-3 fa-external-link btn-subtle title-link"
					@click="openExemplar(exemplar)"
					v-tippy
					title="Open in new window"
				></i>
				<span class="text-theme">Exemplar {{ i + 1 }}</span>
			</div>
			<exemplar :exemplar="exemplar" :key="`e-${exemplar.id}`" />
		</template>
	</div>
</template>

<script>
import Exemplar from "@/components/Exemplar";
import notie from "@/services/NotieService";

export default {
	name: "ExemplarList",
	props: ["exemplars"],
	components: { Exemplar },
	data() {
		return {};
	},

	watch: {},

	created() {},

	methods: {
		setup() {},

		openExemplar(exemplar) {
			this.$emit("openExemplar", exemplar);
		}
	}
};
</script>

<style >
.resource {
	margin-top: 20px;
	position: relative;
	margin-left: auto;
	margin-right: auto;

	min-width: 400px;
	max-width: 800px;
	font-size: 18px;

	/*padding:80px;*/
	-webkit-box-shadow: 3px 3px 11px 1px rgba(184, 182, 184, 1);
	-moz-box-shadow: 3px 3px 11px 1px rgba(184, 182, 184, 1);
	box-shadow: 3px 3px 11px 1px rgba(184, 182, 184, 1);
	background-color: white;
	color: black;
	font-family: "Times New Roman", Times, Georgia, serif;
}
.resource::before {
	content: "";
	float: left;
	width: 1px;
	margin-left: -1px;
	padding-top: 125%;
}
.resource::after {
	content: "";
	display: table;
	clear: both;
}

.loader {
	font-size: 128px;
	text-align: center;
}

.resource:last-of-type {
	margin-bottom: 50px;
}

.respText {
	white-space: pre-wrap; /* css-3 */
	word-wrap: break-word; /* Internet Explorer 5.5+ */
	word-break: normal;
	padding: 80px;
}

.resourceSpinner {
	height: 200px;
	width: 200px;
	margin-left: 300px;
}

a.external-link {
	opacity: 0.7;
	transition: opacity 0.25s;
	text-decoration: underline !important;
}
a.external-link:hover {
	opacity: 1;
}
.title-card {
	padding: 0.25rem 1rem;
	margin-top: 20px;
	margin-bottom: -10px;
	font-weight: 600;
	text-align: center;
}
.title-link {
	position: absolute;
	top: calc(0.25rem + 4px);
	right: 16px;
}
.btn-subtle {
	opacity: 0.35;
	transition: opacity 0.25s;
}
.btn-subtle:hover {
	opacity: 0.7;
}
</style>



// WEBPACK FOOTER //
// src/components/ExemplarList.vue